/**
 * @desc 重新提交审批
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(id: string | number, body: defs.wms.FrozenResubmitOrderDto, options?: any) {
  return updateResponse(
    http(URL + `/wms/frozenCreateOrder/resubmit/${id}`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
